// Code to scroll page to top

(function($) {
    'use strict';
    $('.Button--backToTop').hide();
    $(window).bind('scroll', function() {
        if ($(this).scrollTop() > 250) {
            $('.Button--backToTop').fadeIn('slow');
        } else {
            $('.Button--backToTop').fadeOut('slow');
        }
    });

    $('.Button--backToTop').click(function() {
        event.preventDefault();
        $('html, body').animate({ scrollTop: 0 }, 400);
    });
})(jQuery);
